import { createContext, useContext } from "react";
import { CONST } from "./const";

// custom subdomain based on request

export const isTenantURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[1];

  return typeof subdomain == "string" && subdomain == "tenant";
};

export const IsTenantContext = createContext(false);

export const useIsTenant = () => {
  return useContext(IsTenantContext);
};

export const isBusinessURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  return typeof subdomain == "string" && subdomain.includes("business");
};

export const IsBusinessContext = createContext(false);

export const useIsBusiness = () => {
  return useContext(IsBusinessContext);
};

export const isGateURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = CONST.IS_DEV ? "ares-gate" : "gate";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isMalukuURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = CONST.IS_DEV ? "ares-maluku-gate" : "maluku-gate";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isTrenggalekURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "trenggalekkab";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isPesawaranURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "pesawarankab";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isMuaroJambiURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "muarojambikab";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isJambiURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "jambikota";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isMenpanURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "menpan";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isSupratamaURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "supratama";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isAskrindoURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "askrindo";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isBenemicaURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "benemica";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isBankingURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "banking";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isMenkesURL = (url: string) => {
  let domain = url;

  if (CONST.IS_DEV) {
    const subdomain = domain.split(".")[0];
    const allowedSubdomains = ["menkes", "kemkes"];
    return (
      typeof subdomain == "string" && allowedSubdomains.includes(subdomain)
    );
  } else {
    return (
      domain.includes("kms.kemkes.go.id") ||
      domain.includes("kemkes.learnext.ai")
    );
  }
};

export const isBpsURL = (url: string) => {
  let domain = url;

  if (CONST.IS_DEV) {
    const subdomain = domain.split(".")[0];
    const slugGate: string = "bps";
    return typeof subdomain == "string" && subdomain === slugGate;
  } else {
    return (
      domain.includes("lms.bps.go.id") || domain.includes("bps.learnext.ai")
    );
  }
};

export const isWonderfulLearningURL = (url: string) => {
  let domain = url;

  return domain.includes("wlc.kemenparekraf.go.id");
};

export const isPpsdmAparaturURL = (url: string) => {
  let domain = url;

  return domain.includes("smile.esdm.go.id");
};

export const isKemenperinURL = (url: string) => {
  let domain = url;

  return domain.includes("sippa.kemenperin.go.id");
};

export const isBlueBirdURL = (url: string) => {
  let domain = url;

  // const subdomain = domain.split(".")[0];
  // const slugGate: string = "bluebird";
  // return typeof subdomain == "string" && subdomain === slugGate;

  return domain.includes("e-learning.bluebirdgroup.com");
};

export const isMgmBoscoURL = (url: string) => {
  let domain = url;

  // const subdomain = domain.split(".")[0];
  // const slugGate: string = "mgmbosco";
  // return typeof subdomain == "string" && subdomain === slugGate;

  return domain.includes("mgmbosco.learnext.ai");
};

export const isInjourneyURL = (url: string) => {
  let domain = url;

  return domain.includes("lms.injourney.id");
};

export const isSubdomainBluebird = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "bluebird";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isSubdomainMgmBosco = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "mgmbosco";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isPreviewURL = (url: string) => {
  let domain = url;

  return domain.includes("preview.learnext.ai");
};

export const isBogaURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "boga";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isZurichURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "zurich";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isVisionetURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "visionet";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isGlobalURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "global";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isGlobalIdURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "id";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isGokAresURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "gok-ares-enterprise";
  return (
    (typeof subdomain == "string" && subdomain === slugGate) ||
    domain.includes("gok-ares-enterprise.learnext.ai")
  );
};

export const isGaiaURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "gaia";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isKemendagriURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "kemendagri";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isKapalApiURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "kapalapi";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isBpomURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "bpom";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isBappenasURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "bappenas";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isBnppURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "bnpp";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isCimbniagaURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "cimbniaga";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isSreeyaSewuURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "sreeyasewu";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isSimURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "sim";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isBpsdmJambiURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "bpsdm-jambi";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isKomatsuURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "komatsu";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isUkridaURL = (url: string) => {
  let domain = url;
  const subdomain = domain.split(".")[0];
  const slugGate: string = "ukrida";
  return typeof subdomain == "string" && subdomain === slugGate;
};

export const isMoodleURL = (url: string) => {
  let domain = url;

  if (CONST.IS_DEV) {
    return domain.includes("moodle-ares.learnext.ai");
  } else {
    return (
      domain.includes("moodle.tenant.learnext.ai") ||
      domain.includes("moodle.learnext.ai")
    );
  }
};

export const IsGateContext = createContext(false);
export const IsGateProvinceContext = createContext(false);

export const useIsGate = () => {
  return useContext(IsGateContext);
};

export const useIsGateProvince = () => {
  return useContext(IsGateProvinceContext);
};

export const getSubDomain = (hostname: string) => {
  return hostname.split(".")[0] ?? "";
};

export const getDomain = (hostname: string) => {
  return hostname.split(".")[1] ?? "";
};

export const IsSubdomainContext = createContext(false);

export const useIsSubdomain = () => {
  return useContext(IsSubdomainContext);
};
